// extracted by mini-css-extract-plugin
module.exports = {"getAuthCode":"_3_bhFK87oyOdyNURVzmGF7"};